import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 3.99951L1.50571e-07 7.46361L4.53412e-07 0.53541L6 3.99951Z"
        fill="#3B3B3B"
      />
    </Svg>
  );
};

export default Icon;
